import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { LandPrefixDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-landprefix',
  templateUrl: './landprefix.component.html',
  styleUrls: ['./landprefix.component.scss']
})
export class LandprefixComponent implements OnChanges {

  
  landPrefixForm: FormGroup;
  landPrefixFormArray: FormGroup;
  control = new FormControl();
  @Input() landPrefixs: LandPrefixDto[];
  @Input() routeAnimationsElements: any;
  @Output() landPrefix = new EventEmitter<LandPrefixDto[]>()
  @Output() deleteLandPrefixEvent = new EventEmitter<any>()

    selectedLandPrefix: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     ) {}

    ngOnChanges() {
      this.createLandPrefixForm();
    }

    createLandPrefixForm() {
      this.landPrefixForm = this.fb.group({
        LandPrefixCode: ['', Validators.required],
        LandPrefixName: ['', Validators.required],
        id: null
        });
        this.landPrefixFormArray = this.fb.group({ LandPrefixs: this.fb.array([])
          });
        this.setLandPrefix();
    }

  // method to display LandPrefixs
  setLandPrefix() {
    const control  = this.landPrefixFormArray.controls.LandPrefixs as FormArray;
    this.landPrefixs.forEach( e => {
      control.push(
        this.fb.group({
          LandPrefixCode: e.LandPrefixCode,
          LandPrefixName: e.LandPrefixName,         
          id: e.id
        })
      );
    });
  }


  // method to add LandPrefix
  addLandPrefix(value: LandPrefixDto) {
    const control  = this.landPrefixFormArray.controls.LandPrefixs as FormArray;
    control.insert(0,
          this.fb.group({
            LandPrefixCode: value.LandPrefixCode,
            LandPrefixName: value.LandPrefixName,
            id: null
          })
       );
  }

  selectLandPrefix(value) {


  }

  // method to delete LandPrefix from arrary list
  deleteLandPrefix(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.landPrefixFormArray.controls.LandPrefixs as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.landPrefixs.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.landPrefixs[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: LandPrefixDto) {
    if(this.landPrefixForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.landPrefixFormArray.get('LandPrefixs')['controls'][this.selectedIndex].patchValue({LandPrefixName: formValue.LandPrefixName});
    } else {
      this.addLandPrefix(formValue);
    }
    this.selectedIndex = null;
    this.landPrefixForm.reset()
  }

  onEdit(index, value: LandPrefixDto) {
    console.log(index, value)
    this.selectedIndex = index;
    this.landPrefixForm.patchValue({LandPrefixCode: value.LandPrefixCode,LandPrefixName: value.LandPrefixName});
  }

  onClearForm() {
    this.selectedIndex = null;
    this.landPrefixForm.reset();
  }

  onSubmit(formValue: LandPrefixDto[]) {
  this.landPrefix.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteLandPrefixEvent.emit(this.filteredDelete);
  }
  }


}
